import tosText from '../../../../backend/public/docs/tos_freelancer_v2.txt?raw';

const renderLines = (text) => text.split('\n').map((line, i) => (
    line.trim() === ''
        ? <div key={i} style={{ height: '0.5rem' }} />
        : <p key={i} style={{ margin: '0.25rem 0', whiteSpace: 'pre-wrap' }}>{line}</p>
));

export const TosFreelancerUnstyled = () => <>{renderLines(tosText)}</>;
